import React from "react";
import { Paper, useMediaQuery, useTheme } from "@mui/material";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { MaterialReactTable } from "material-react-table";
import TableCards from "../tableCards/tableCards";
import { tokens } from "../../../theme";

interface TableTemplateProps {
  tableData: any;
  /** Column ids to lead with in the mobile cards, in order. */
  primaryColumns?: string[];
}

/**
 * Every table goes through here, so the mobile fallback lands in one place:
 * below `md` the grid becomes a list of cards. material-react-table has no card
 * renderer of its own, and a 12-column table is unusable on a phone.
 */
const TableTemplate = (props: TableTemplateProps) => {
  const { tableData, primaryColumns } = props;
  const theme = useTheme();
  const isCompact = useMediaQuery(theme.breakpoints.down("md"));

  // LEGACY — the old app had no mobile table behaviour. Delete with the rest
  // of the legacy shell.
  if (isCompact && tokens.shell !== "legacy") {
    return <TableCards table={tableData} primaryColumns={primaryColumns} />;
  }

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MaterialReactTable table={tableData} />
      </LocalizationProvider>
    </Paper>
  );
};

export default TableTemplate;
